import React from 'react';
import { ItableColumn } from 'components/Table/type';
import { FieldPath } from 'react-hook-form';
import {
  EnumDetail,
  EnumQueryResults,
  IqueryResults,
  RtnQueryFormDetail,
} from '../../init';

export const nameDetail = (
  field: FieldPath<typeof EnumDetail>,
  index: number,
): FieldPath<RtnQueryFormDetail> => `detail.${index}.${field}`;

export const getColumns = (controlData: IqueryResults): ItableColumn[] => {
  return [
    {
      title: '',
      field: 'selected',
      show: controlData[EnumQueryResults.checkbox],
    },

    {
      title: '項次',
      field: 'itemNo',
    },
    {
      title: '體系別',
      field: EnumDetail.retailerName,
      show: controlData[EnumQueryResults.retailerId],
    },
    {
      title: (
        <div>
          分店
          <br />
          倉庫名稱
        </div>
      ),
      field: EnumDetail.buyerGLN,
      show: controlData[EnumQueryResults.storeNo],
      dataTitle: '分店倉庫名稱',
    },
    {
      title: '退貨通知單號碼',
      field: EnumDetail.returnNoteNo,
      show: controlData[EnumQueryResults.returnNoteNo],
    },
    {
      title: '退貨通知日期',
      field: EnumDetail.returnNoteDate,
      show: controlData[EnumQueryResults.returnNoteDate],
    },
    {
      title: '退貨驗收單號碼',
      field: EnumDetail.returnNo,
      show: controlData[EnumQueryResults.returnNo],
    },
    {
      title: '退貨驗收日期',
      field: EnumDetail.returnDate,
      show: controlData[EnumQueryResults.returnDate],
    },
    {
      title: '備註',
      field: EnumDetail.generalInfo,
      show: controlData[EnumQueryResults.generalInfo],
    },
    {
      title: '廠編',
      field: EnumDetail.supplierCode,
      show: controlData[EnumQueryResults.supplierCode],
    },
    {
      title: '廠商簡稱',
      field: EnumDetail.supplierBriefName,
      show: controlData[EnumQueryResults.supplierBriefName],
    },
    {
      title: '退貨通知單狀態',
      field: EnumDetail.returnStat,
      show: controlData[EnumQueryResults.returnStat],
    },
    {
      title: '結帳日',
      field: EnumDetail.closeDate,
      show: controlData[EnumQueryResults.closeDate],
    },
    {
      title: '點閱紀錄',
      field: EnumDetail.viewed,
      show: controlData[EnumQueryResults.viewed],
    },
    {
      title: (
        <div>
          文字檔
          <br />
          下載紀錄
        </div>
      ),
      field: EnumDetail.downloaded,
      show: controlData[EnumQueryResults.downloaded],
      dataTitle: '文字檔下載紀錄',
    },
    {
      title: '最後異動時間',
      field: EnumDetail.updDate,
      show: controlData[EnumQueryResults.updDate],
    },
  ];
};
